import { runtimeConfig } from '@/shared/config'

// PUT /api/employees/me/timezone — машинная ручка хаба: зону называет SPA, а не
// человек из формы. Адресата в пути нет, субъект берётся из hub-cookie — отсюда
// credentials:'include' на чужой origin. Запрос идёт мимо `apiClient`: тот ходит
// к бэкенду продукта, а проекция зоны живёт в хабе. Ручка идемпотентна —
// совпавшее значение хаб не пишет, поэтому сверять с сохранённым не нужно.
export function reportDeviceTimezone(timezone: string): Promise<Response> {
  return fetch(`${runtimeConfig.ID_BASE_URL}/api/employees/me/timezone`, {
    method: 'PUT',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ timezone }),
  })
}
